var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ colorCard: true, active: _vm.isActive },on:{"click":_vm.selectColor}},[_c('div',{staticClass:"colorCard-img"},[_c('img',{attrs:{"src":_vm.defaultImg,"alt":"Cor interior do carro"}})]),_c('p',{staticClass:"colorCard-content"},[_vm._v(_vm._s(_vm.colorDesignation))])])
}
var staticRenderFns = []

export { render, staticRenderFns }